import React, {useEffect, useState} from "react";
import IbatApi from "../../utils/IbatApi";
import {IconButton} from "@mui/material";
import CatalogEdit from "../admin/catalog/CatalogEdit";
import NomenclatureEdit from "./nomenclature/NomenclatureEdit";
import ContactCrud from "./beans/ContactHelp";
import CompanyCrud from "./beans/CompanyUpdater";
import RiskAnalysisManager from "./beans/RiskAnalysisManager";
import JobManager from "./beans/JobManager";
// import Papa from 'papaparse';

const api = new IbatApi()



function JobTypeCrud({jtList, refresh}){
    const [newJt, setNewJt] = useState();
    function showJobType(jt){
        return(
            <div className={"jobType"}>
                <span>id: <b>{jt?.id}</b></span><br />
                <span>name: <b>{jt?.name}</b></span><br /><br />
            </div>
        )
    }
    function handleNewJobType(){
        const jt = document.getElementById("jobTypeCreator")?.value
        setNewJt(false)
        api.saveJobType({id:null, name:jt}).then(resp=> {
            refresh()
        })
    }
    return (
        <div>
            {jtList?.map(jt => showJobType(jt))}
            {
                newJt &&
                <div>
                    <input type={"text"} placeholder={"Roofer"} id={"jobTypeCreator"}/>
                    <IconButton className={"action-btn validation"} onClick={handleNewJobType}>Valider</IconButton>

                </div>
            }
            <IconButton className={"action-btn validation"} onClick={()=>setNewJt(true)}>Créer un corps de métier</IconButton>
        </div>
    )
}


export default function AdminCrud() {
    const api = new IbatApi()
    const [godMode, setGodMode] = useState("Waiting")
    const [showQuestion, setShowQuestion] = useState(false);

    // CSV upload states
    const [csvFile, setCsvFile] = useState(null);



    const [jobTypeList, setJobTypeList] = useState();

    function getJobTypeNameList(idList){
        return jobTypeList.filter(jt => idList?.includes(jt.id)).map(jt => jt.name)
    }

    useEffect(() => {
        if (!godMode || godMode === "Waiting"){
            api.amISuperAdmin().then(r => {
                setGodMode(r)
            })
        }
        if (godMode === true){
            refreshJobType()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [godMode])

    function refreshJobType(){
        api.getJobTypes().then(resp=> setJobTypeList(resp))
    }



    function handleCsvInputChange(e){
        const file = e?.target?.files?.[0];
        setCsvFile(file || null);
    }

    function normalizeBlank(value){
        if (value === undefined || value === null) return null;
        const v = ("" + value).trim();
        return v === "" ? null : v;
    }

    function isValidDateFR(v){
        if (!v) return false;
        const m = /^([0-3]\d)\/(0\d|1[0-2])\/(\d{4})$/.exec(v);
        if (!m) return false;
        const d = parseInt(m[1],10), mo = parseInt(m[2],10)-1, y = parseInt(m[3],10);
        const dt = new Date(y, mo, d);
        return dt.getFullYear()===y && dt.getMonth()===mo && dt.getDate()===d;
    }

    function leftPad(str, len){
        str = String(str ?? "");
        if (str.length >= len) return str;
        return "0".repeat(len - str.length) + str;
    }

    function parseCsvText(text){
        const sirenPrefix = "322424342"; // fixed company SIREN to prepend
        const lines = text.replace(/\r\n?/g, "\n").split("\n").filter(l => l.trim() !== "");
        if (lines.length === 0) {
            console.log("[CSV] Empty file");
            return {data: [], ignored: []};
        }
        const header = lines[0].split(";").map(h => h.trim().toLowerCase());
        const expected = ["site_id","siret","pdv","ville","roof_surface","roof_creation","landlord","external_maintenance","maintenance_rate"];
        const idx = {};
        expected.forEach(k => { idx[k] = header.indexOf(k); });
        const missing = expected.filter(k => idx[k] === -1);
        if (missing.length) {
            console.warn("[CSV] Missing columns:", missing);
        }

        const data = [];
        const ignored = [];

        for (let i = 2; i < lines.length; i++){
            const rawLine = lines[i];
            if (rawLine.trim() === "") continue;
            const cols = rawLine.split(";");

            const row = {};
            expected.forEach(k => {
                const v = idx[k] >= 0 ? cols[idx[k]] : undefined;
                row[k] = v !== undefined ? String(v).trim() : undefined;
            });

            // Normalize blanks to null
            Object.keys(row).forEach(k => { row[k] = normalizeBlank(row[k]); });

            // SIRET (NIC): if numeric, left-pad to 5 and build full SIRET; else set to null (do not ignore line)
            let siretNic = row["siret"];
            let siretFull = null;
            if (siretNic !== null && /^\d+$/.test(siretNic)) {
                siretFull = `${sirenPrefix}${leftPad(siretNic, 5)}`;
            }
            else {
                siretFull = `${sirenPrefix}xxxxx`;
            }

            // roof_creation must be dd/mm/yyyy else null
            let roofCreation = row["roof_creation"];
            if (!isValidDateFR(roofCreation)) {
                roofCreation = null;
            }

            // roof_surface: keep digits only (ignore trailing 'm' etc.)
            let surface = row["roof_surface"];
            if (surface !== null) {
                const digits = (surface.match(/\d+/g) || []).join("");
                surface = digits === "" ? null : parseInt(digits, 10);
            }

            const siteId = row["site_id"] === null ? null : row["site_id"];
            const pdv = row["pdv"] ?? "";
            const ville = row["ville"] ?? "";
            const maintenanceRate = row["maintenance_rate"] === null ? null : row["maintenance_rate"];
            const landlord = row["landlord"] === null ? null : row["landlord"];
            const externalMaintenance = row["external_maintenance"] === null ? null : row["external_maintenance"];

            // Build object per spec
            const obj = {
                id: siteId,
                name: `GEMO ${pdv ?? ""} ${ville ?? ""}`.trim(),
                siret: siretFull,
                roofSurface: surface,
                roofCreation: roofCreation,
                maintenanceRate: maintenanceRate,
                landlord: landlord,
                externalMaintenance: externalMaintenance
            };

            data.push(obj);
        }

        return {data, ignored};
    }

    function handleProcessCsv(){
        if (!csvFile){
            console.log("[CSV] Aucun fichier sélectionné");
            return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            try{
                const text = e?.target?.result || "";
                const {data, ignored} = parseCsvText(text);
                console.log("[CSV] Objets convertis:", data);
                console.log("[CSV] Lignes ignorées:", ignored);
                alert(`CSV traité. Objets: ${data.length}. Lignes ignorées: ${ignored.length}. Consultez la console pour le détail.`);
                api.updateGemoSite(data)
            }catch(err){
                console.error("[CSV] Erreur lors du parsing:", err);
                alert("Erreur lors du parsing du CSV. Voir console.");
            }
        };
        reader.onerror = () => {
            console.error("[CSV] Erreur de lecture du fichier");
            alert("Erreur de lecture du fichier");
        };
        reader.readAsText(csvFile, 'utf-8');
    }

    if (godMode === true){
        return (
            <div className={"page grid admin"}>
                <aside className={"menu secondary-section flex-column"}>
                    <h2 className={"MuiIconButton-root action-btn neutral"} onClick={() => setShowQuestion("contacts")}>Contacts</h2>
                    <h2 className={"MuiIconButton-root action-btn neutral"} onClick={() => setShowQuestion("company")}>Entreprises</h2>
                    <h2 className={"MuiIconButton-root action-btn neutral"} onClick={() => setShowQuestion("raConfig")}>Analyses de risques</h2>
                    <h2 className={"MuiIconButton-root action-btn neutral"} onClick={() => setShowQuestion("job")}>Métier</h2>
                    <h2 className={"MuiIconButton-root action-btn neutral"} onClick={() => setShowQuestion("jobtype")}>Corps de métier</h2>
                    <h2 className={"MuiIconButton-root action-btn neutral"} onClick={() => setShowQuestion("catalogEdit")}>Catalogue </h2>
                    <h2 className={"MuiIconButton-root action-btn neutral"} onClick={() => setShowQuestion("nomenclatureEdit")}>Nomenclatures </h2>
                </aside>

                <article>
                    {showQuestion === "contacts" && <ContactCrud/>}
                    {showQuestion === "company" && <CompanyCrud/>}
                    {showQuestion === "raConfig" && <RiskAnalysisManager getJobTypeNameList={getJobTypeNameList}/>}
                    {showQuestion === "job" && <JobManager getJobTypeNameList={getJobTypeNameList}/>}

                    {showQuestion === "jobtype" && <JobTypeCrud refresh={refreshJobType} jtList={jobTypeList}/>}
                    {showQuestion === "catalogEdit" && <CatalogEdit jobTypes={jobTypeList?.map(jt => {var jobtype = {id: jt.id, value: jt.id, name: jt.name, label: jt.name};return jobtype})} />}
                    {showQuestion === "nomenclatureEdit" && <NomenclatureEdit jobTypes={jobTypeList?.map(jt => {var jobtype = {id: jt.id, value: jt.id, name: jt.name, label: jt.name};return jobtype})} />}

                    <div style={{marginTop: 24}}>
                        <h3>Import CSV sites</h3>
                        <input type="file" accept=".csv,text/csv" onChange={handleCsvInputChange} />
                        <IconButton className={"action-btn validation"} onClick={handleProcessCsv} disabled={!csvFile}>
                            Traiter le CSV
                        </IconButton>
                        <div style={{fontSize: 12, opacity: 0.7}}>
                            Entêtes attendues: site_id;siret;pdv;ville;roof_surface;roof_creation;landlord;external_maintenance;maintenance_rate
                        </div>
                    </div>
                </article>
            </div>
        )
    }
    else {
        return "Not Found"
    }
}

